import { ChevronRightIcon, HomeIcon } from "@heroicons/react/20/solid";
import Link from "@packages/components/ui/Link";

interface Page {
  name: string;
  href: string | null;
  current: boolean;
}

interface BreadcrumbProps {
  pages: Page[];
}

export default function Breadcrumb({ pages }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol role="list" className="flex items-center space-x-3 py-3 sm:space-x-4">
        <li>
          <div>
            <Link
              href="/"
              className="text-muted-foreground hover:text-link-gray-hover block"
              noDefaultColor
            >
              <HomeIcon aria-hidden="true" className="size-5 shrink-0" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index) => (
          <li key={`${page.name}-${page.href ?? index}`}>
            <div className="flex items-center">
              <ChevronRightIcon
                aria-hidden="true"
                className="text-muted-foreground size-5 shrink-0"
              />
              {page.current ? (
                <span className="text-muted-heading ml-4 line-clamp-2 cursor-default text-sm font-medium">
                  {page.name}
                </span>
              ) : (
                <Link
                  href={page.href!}
                  aria-current={page.current ? "page" : undefined}
                  className="text-muted-heading hover:text-link-gray-hover ml-4 line-clamp-2 text-sm font-medium"
                >
                  {page.name}
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
